import "@/App.css";
import { Toaster } from "sonner";
import Analyzer from "@/pages/Analyzer";

function App() {
  return (
    <div className="App">
      <Analyzer />
      <Toaster theme="dark" position="top-center" richColors />
    </div>
  );
}

export default App;
